import { useEffect, useState } from "react";
import { useReducedMotion } from "react-native-reanimated";

export const ELLIPSES_INTERVAL = 300;
export const SINGLE_ELLIPSES_CYCLE = 4 * ELLIPSES_INTERVAL;
export const TRANSITION_DURATION = 300;

/**
 * Renders ellipses that blink in a loop.
 * If reduced motion is enabled, it will render 3 static dots.
 * This component must be provided a parent Typography component in React Native
 */
export default function Ellipses() {
  const reducedMotion = useReducedMotion();
  const [ellipsesCount, setEllipsesCount] = useState(3);

  useEffect(() => {
    if (reducedMotion) return;

    const intervalId = setInterval(() => {
      setEllipsesCount((prev) => (prev + 1) % 4);
    }, ELLIPSES_INTERVAL);

    return () => clearInterval(intervalId);
  }, [reducedMotion]);

  // Always render 3 dots with varying opacity to prevent layout shift
  return (
    <>
      <span style={{ opacity: ellipsesCount >= 1 ? 1 : 0 }}>.</span>
      <span style={{ opacity: ellipsesCount >= 2 ? 1 : 0 }}>.</span>
      <span style={{ opacity: ellipsesCount >= 3 ? 1 : 0 }}>.</span>
    </>
  );
}
